<template>
    <div :style="{fontSize:fSize+'px'}">
        <slot></slot>
    </div>
</template>

<script>

    let defaultWidth = 1280,
        defaultFont = 16,
        minWidth = 768,
        minHeight = 600,
        defaultHeight = 728;

    export default {
        name: 'Resize',
        props: ['mobile', 'mobMenuShow'],
        mounted () {
            window.addEventListener('resize',this.onResize.bind(this));
            return this.mobMenuShow;
        },
        data () {
            return {
                vW:  window.innerWidth,
                vH:  window.innerHeight,
            }
        },
        computed: {
            fSize () {
                if (this.mobile) {
                    return 16;
                }
                if (this.vW < 1500){
                    return (16*Math.min(Math.max(minWidth,this.vW)/defaultWidth,Math.max(minHeight,this.vH)/defaultHeight) + 1);
                }
                return 16*Math.min(Math.max(minWidth,this.vW)/defaultWidth,Math.max(minHeight,this.vH)/defaultHeight);
            },
        },
        methods: {
            onResize () {
                this.vW = window.innerWidth;
                this.vH = window.innerHeight;
            }
        }

    }
</script>




// WEBPACK FOOTER //
// Resize.vue?07ba0ed1